
import { useParams } from "react-router-dom";
import MainLayout from "@/components/layout/MainLayout";
import PageSEO from "@/components/seo/PageSEO";

const SessionDetail = () => {
  const { id } = useParams();
  
  // In a real app, you would fetch session details based on the ID
  // For now, we'll use a placeholder
  const sessionDetails = {
    id: Number(id),
    title: `sessão ${id}`,
    date: '14 de maio, 2025',
    content: 'Detalhes da sessão estarão disponíveis aqui.'
  };
  
  // Define breadcrumbs for better SEO
  const breadcrumbs = [
    {
      position: 1,
      name: "Início",
      item: "https://vivecalme.org/app"
    },
    {
      position: 2,
      name: "Histórico",
      item: "https://vivecalme.org/historico"
    },
    {
      position: 3,
      name: `Sessão ${id}`,
      item: `https://vivecalme.org/sessao/${id}`
    }
  ];
  
  return (
    <MainLayout>
      <PageSEO
        title={`Sessão ${id} | Vive Calme`}
        description={`Detalhes da sua sessão ${id} na plataforma Vive Calme. Revise seu progresso e insights de saúde mental.`}
        canonicalUrl={`https://vivecalme.org/sessao/${id}`}
        pageName={`Detalhes da Sessão ${id}`}
        breadcrumbs={breadcrumbs}
        // Add structured data for a mental health session
        structuredData={{
          "@type": "MedicalProcedure",
          procedureType: "Mental Health Session",
          name: `Sessão ${id}`,
          date: sessionDetails.date
        }}
      />
      
      <div className="container mx-auto p-6">
        <h1 className="text-2xl font-bold mb-2">{sessionDetails.title}</h1>
        <p className="text-sm text-gray-500 mb-8">{sessionDetails.date}</p>
        
        <div className="bg-white p-6 rounded-lg shadow-sm border">
          <p>{sessionDetails.content}</p>
        </div>
      </div>
    </MainLayout>
  );
};

export default SessionDetail;
